import produce from 'immer';

const INITIAL_STATE = {
  loadingTabs: false,
  tabs_consulta: [],
  tabs_analise: [],
  currentFila: '',
};

export default function proposta(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@proposta/LOAD_TABS_CONSULTA_REQUEST': {
        draft.loadingTabs = true;
        break;
      }

      case '@proposta/LOAD_TABS_CONSULTA_SUCCESS': {
        draft.tabs_consulta = action.payload.tabs;
        draft.loadingTabs = false;
        break;
      }

      case '@proposta/LOAD_TABS_CONSULTA_FAILURE': {
        draft.tabs_consulta = [];
        draft.loadingTabs = false;
        break;
      }

      case '@proposta/LOAD_TABS_ANALISE_REQUEST': {
        draft.loadingTabs = true;
        break;
      }

      case '@proposta/LOAD_TABS_ANALISE_SUCCESS': {
        draft.tabs_analise = action.payload.tabs;
        draft.loadingTabs = false;
        break;
      }

      case '@proposta/LOAD_TABS_ANALISE_FAILURE': {
        draft.tabs_analise = [];
        draft.loadingTabs = false;
        break;
      }

      case '@proposta/SET_CURRENT_FILA': {
        draft.currentFila = action.payload;
        break;
      }

      default:
    }
  });
}
